import script from "./CurtainItemModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CurtainItemModal.vue?vue&type=script&setup=true&lang=js"

import "./CurtainItemModal.vue?vue&type=style&index=0&id=49cdc386&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49cdc386"]])

export default __exports__